module.exports = __webpack_public_path__ + "img/poster-default-mini.4e2e4933.jpg";